import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Content", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Colors", -1)
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Background", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_DigitalAssetUpload = _resolveComponent("DigitalAssetUpload")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "headline1",
          label: "Headline 1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.headline1,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.signageItemLayoutData.headline1) = $event)),
              placeholder: "Header"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "headline2",
          label: "Headline 2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.headline2,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageItemLayoutData.headline2) = $event)),
              placeholder: "Headline 2"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          class: "col-lg-6",
          prop: "secondaryHeadline",
          label: "Secondary Headline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.signageItemLayoutData.secondaryHeadline,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signageItemLayoutData.secondaryHeadline) = $event)),
              placeholder: "Secondary Headline"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_divider, { class: "mt-0" }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "fontBackgroundColor",
            label: "Font Background Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.fontBackgroundColor,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.signageItemLayoutData.fontBackgroundColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            class: "me-4",
            prop: "fontColor",
            label: "Font Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.fontColor,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.signageItemLayoutData.fontColor) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            prop: "backgroundColor",
            label: "Background Color"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_color_picker, {
                disabled: _ctx.signageItemLayoutData.useBackgroundMedia,
                class: "mt-1",
                modelValue: _ctx.signageItemLayoutData.backgroundColor,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.signageItemLayoutData.backgroundColor) = $event))
              }, null, 8, ["disabled", "modelValue"])
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_divider, { class: "mt-0" }),
        _hoisted_6,
        _createVNode(_component_el_form_item, { label: "Use Background Media" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.signageItemLayoutData.useBackgroundMedia,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.signageItemLayoutData.useBackgroundMedia) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (_ctx.signageItemLayoutData.useBackgroundMedia)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "Background Media"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DigitalAssetUpload, {
                  allowVideo: "true",
                  sizeLimitMB: "300",
                  layoutProperty: "asset1",
                  layoutType: _ctx.layoutType,
                  assetUrl: _ctx.assetUrl
                }, null, 8, ["layoutType", "assetUrl"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}